<p>geotest works!</p>

    <geo-editor gml="gml" [isSurface]="true" idPrefix="line1"></geo-editor>


